import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "jby_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    if (typeof window === "undefined") return [];
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch {}
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((p) => p.product_id === product.id);
      if (found) {
        return prev.map((p) =>
          p.product_id === product.id ? { ...p, quantity: p.quantity + qty } : p
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          slug: product.slug,
          title: product.title,
          price: product.price,
          price_inr: product.price_inr,
          image: product.image,
          type: product.type,
          quantity: qty,
        },
      ];
    });
    setIsOpen(true);
  };

  const updateQty = (productId, qty) => {
    setItems((prev) =>
      prev
        .map((p) => (p.product_id === productId ? { ...p, quantity: qty } : p))
        .filter((p) => p.quantity > 0)
    );
  };

  const removeItem = (productId) =>
    setItems((prev) => prev.filter((p) => p.product_id !== productId));

  const clearCart = () => setItems([]);

  const totalItems = items.reduce((s, p) => s + p.quantity, 0);
  const subtotal = items.reduce((s, p) => s + p.price * p.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, isOpen, setIsOpen, addItem, updateQty, removeItem, clearCart, totalItems, subtotal }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
